<script lang="ts">
  export type SemaforoData = {
    totalCamas?: number;
    ocupadas?: number;
    disponibles?: number;
    tasaOcupacionPct?: number;
    porColor?: Record<string, number>;
    porEstado?: Record<string, number>;
    porServicio?: Record<string, Record<string, number> | number>;
  };

  let {
    data = null as SemaforoData | null,
    compact = false,
    showTables = true,
  }: {
    data?: SemaforoData | null;
    compact?: boolean;
    showTables?: boolean;
  } = $props();
</script>

{#if data}
  <div class="grid" class:compact>
    <div class="card verde"><h3>Disponibles</h3><p class="big">{data.porColor?.verde ?? 0}</p></div>
    <div class="card amarillo"><h3>Limpieza / asignadas</h3><p class="big">{data.porColor?.amarillo ?? 0}</p></div>
    <div class="card rojo"><h3>Ocupadas</h3><p class="big">{data.porColor?.rojo ?? 0}</p></div>
    <div class="card gris"><h3>Mantenimiento</h3><p class="big">{data.porColor?.gris ?? 0}</p></div>
    <div class="card total">
      <h3>{compact ? 'Ocupación' : 'Total camas'}</h3>
      <p class="big">{compact ? `${data.tasaOcupacionPct ?? 0}%` : (data.totalCamas ?? 0)}</p>
      {#if compact && data.totalCamas != null}
        <small>{data.ocupadas ?? 0} / {data.totalCamas}</small>
      {/if}
    </div>
  </div>

  {#if showTables && !compact}
    <h4>Por servicio</h4>
    <table>
      <thead><tr><th>Servicio</th><th>Detalle</th></tr></thead>
      <tbody>
        {#each Object.entries(data.porServicio ?? {}) as [svc, n]}
          <tr>
            <td>{svc}</td>
            <td>{typeof n === 'object' ? JSON.stringify(n) : n}</td>
          </tr>
        {/each}
      </tbody>
    </table>
  {/if}
{/if}

<style>
  .grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 0.75rem; margin: 0.5rem 0 1rem; }
  .grid.compact { grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); }
  .card { padding: 0.85rem 1rem; border-radius: var(--radius-xl); color: #fff; backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px); border: 1px solid rgba(255,255,255,0.2); }
  .card h3 { margin: 0; font-size: 0.82rem; font-weight: 500; opacity: 0.92; }
  .card .big { margin: 0.35rem 0 0; font-size: 2rem; font-weight: 800; line-height: 1; }
  .card small { opacity: 0.9; font-size: 0.72rem; }
  .verde { background: linear-gradient(135deg, #059669, #10b981); box-shadow: 0 4px 16px rgba(16,185,129,0.3); }
  .amarillo { background: linear-gradient(135deg, #d97706, #f59e0b); color: #78350f; box-shadow: 0 4px 16px rgba(245,158,11,0.3); }
  .rojo { background: linear-gradient(135deg, #dc2626, #ef4444); box-shadow: 0 4px 16px rgba(239,68,68,0.3); }
  .gris { background: linear-gradient(135deg, #4b5563, #6b7280); box-shadow: 0 4px 16px rgba(107,114,128,0.3); }
  .total { background: linear-gradient(135deg, #5b21b6, #7c3aed, #8b5cf6); box-shadow: 0 4px 20px rgba(124,58,237,0.4); }
  h4 { margin: 1rem 0 0.5rem; font-size: 0.95rem; color: var(--text-primary); }
  table { width: 100%; border-collapse: collapse; margin-bottom: 0.5rem; }
  th, td { padding: 0.45rem 0.55rem; border-bottom: 1px solid var(--glass-border); text-align: left; font-size: 0.85rem; color: var(--text-primary); }
  th { color: var(--text-secondary); font-weight: 600; }
</style>
